// extracted by mini-css-extract-plugin
export default {"root":"root--u_j8aSsu","selectedCheckbox":"selectedCheckbox--WERC5RXj"};